import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-tile" }
const _hoisted_2 = { class: "info-content" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "position-block" }
const _hoisted_5 = { class: "company" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Divider = _resolveComponent("Divider")
  const _component_CompanyType = _resolveComponent("CompanyType")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Image, {
      name: $options.c_name,
      size: "4rem",
      src: $props.avatar,
      shape: "circle"
    }, null, 8 /* PROPS */, ["name", "src"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($options.c_name), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        ($props.position)
          ? (_openBlock(), _createBlock(_component_Ellipsis, {
              key: 0,
              class: "position",
              text: $props.position
            }, null, 8 /* PROPS */, ["text"]))
          : _createCommentVNode("v-if", true),
        ($props.company)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_Divider, {
                class: "divider",
                vertical: "",
                m: "0",
                h: "1rem"
              }),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Image, {
                  src: $props.company.logo_url,
                  size: "1.6rem",
                  shape: "square",
                  placeholder: "assets/company-placeholder.png"
                }, null, 8 /* PROPS */, ["src"]),
                _createTextVNode(" " + _toDisplayString($props.company.name), 1 /* TEXT */)
              ]),
              ($props.company.type || $props.company.tracker_type)
                ? (_openBlock(), _createBlock(_component_CompanyType, {
                    key: 0,
                    class: "company-type",
                    type: $props.company.type || $props.company.tracker_type
                  }, null, 8 /* PROPS */, ["type"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}